import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module'; // Import AppRoutingModule
import { FormsModule } from '@angular/forms';

import { AppComponent } from './app.component';
import { TarcaComponent } from './tarca/tarca.component';
import { VecTarcComponent } from './vec-tarc/vec-tarc.component';
import { NavbarComponent } from './navbar/navbar.component';
import { RezultatiComponent } from './rezultati/rezultati.component';
import { StrelciComponent } from './strelci/strelci.component';
import { StrelciFilterDialogComponent } from './dialogs/strelci-filter-dialog/strelci-filter-dialog.component';
import { StrelciAddDialogComponent } from './dialogs/strelci-add-dialog/strelci-add-dialog.component';
import { TekmeComponent } from './tekme/tekme.component';
import { TekmeAddDialogComponent } from './dialogs/tekme-add-dialog/tekme-add-dialog.component';
import { RezultatiAddDialogComponent } from './dialogs/rezultati-add-dialog/rezultati-add-dialog.component';
import { TarcaAddDialogComponent } from './dialogs/tarca-add-dialog/tarca-add-dialog.component';
import { CategoriesComponent } from './categories/categories.component';
import { CategoryAddDialogComponent } from './dialogs/category-add-dialog/category-add-dialog.component';
import { RezultatiTekemComponent } from './rezultati-tekem/rezultati-tekem.component'; // Import TarcaComponent
import { LoginComponent } from './login/login.component';
import { SettingsComponent } from './settings/settings.component';
import { KlubiComponent } from './klubi/klubi.component';
import { ClubAddDialogComponent } from './dialogs/club-add-dialog/club-add-dialog.component';

@NgModule({
  declarations: [
    AppComponent,
    TarcaComponent,
    VecTarcComponent,
    NavbarComponent,
    RezultatiComponent,
    StrelciComponent,
    StrelciFilterDialogComponent,
    StrelciAddDialogComponent,
    TekmeComponent,
    TekmeAddDialogComponent,
    RezultatiAddDialogComponent,
    TarcaAddDialogComponent,
    CategoriesComponent,
    CategoryAddDialogComponent,
    RezultatiTekemComponent, // Declare TarcaComponent
    LoginComponent,
    SettingsComponent,
    KlubiComponent,
    ClubAddDialogComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule, // Add AppRoutingModule
    FormsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {}
